import { api } from './api'
import {
  NormalizationType,
  NormalizationsResponse,
  CreateNormalizationRequest,
  UpdateNormalizationRequest,
  AIGenerationRequest,
  AIGenerationResponse
} from '@/types/normalization'

// Re-export types for consumers of this service
export type {
  NormalizationType,
  NormalizationsResponse,
  CreateNormalizationRequest,
  UpdateNormalizationRequest,
  AIGenerationRequest,
  AIGenerationResponse
}

class NormalizationsService {
  async list(page = 1, size = 30): Promise<NormalizationsResponse> {
    const params = { page, size }
    
    console.log('🌐 Normalizations API request params:', params)
    console.log('🌐 Current URL for org slug extraction:', window.location.pathname)
    
    // Note: Organization is handled by the API interceptor via X-Organization-Slug header
    const response = await api.get('/normalizations/', { params })
    
    console.log('🌐 Normalizations raw response status:', response.status)
    console.log('🌐 Normalizations raw response data:', response.data)
    console.log('🌐 Normalizations response headers:', response.headers)
    
    // Backend returns array directly, but frontend expects wrapper object
    if (Array.isArray(response.data)) {
      return {
        normalizations: response.data,
        total: response.data.length,
        page: page,
        size: size
      }
    }
    
    return response.data
  }

  async show(id: number): Promise<NormalizationType> {
    const response = await api.get(`/normalizations/${id}`)
    return response.data
  }

  async create(data: CreateNormalizationRequest): Promise<NormalizationType> {
    const response = await api.post('/normalizations/', data)
    return response.data
  }

  async update(id: number, data: UpdateNormalizationRequest): Promise<NormalizationType> {
    const response = await api.put(`/normalizations/${id}`, data)
    return response.data
  }

  async delete(id: number): Promise<void> {
    await api.delete(`/normalizations/${id}`)
  }

  async generateWithAI(data: AIGenerationRequest): Promise<AIGenerationResponse> {
    const response = await api.post('/normalizations/ai', data)
    return response.data
  }

  async testNormalization(id: number, testData: any): Promise<any> {
    const response = await api.post(`/normalizations/${id}/test`, { data: testData })
    return response.data
  }

  async bulkImport(file: File): Promise<{ imported: number; errors: string[] }> {
    const formData = new FormData()
    formData.append('file', file)
    
    const response = await api.post('/normalizations/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response.data
  }

  async export(format: 'json' | 'csv' = 'json'): Promise<Blob> {
    const response = await api.get(`/normalizations/export?format=${format}`, {
      responseType: 'blob'
    })
    return response.data
  }
}

export const normalizationsService = new NormalizationsService()